export interface FacetDocument {
  count: number;
  value: string;
}

export enum ProviderFacetKeys {
  insuranceAliasValues = 'location/insurances/aliasVal',
  rating = 'ratings/overallRating',
  locationName = 'locations/name',
  insurancePlanNcid = 'location/insurances/ncid',
  language = 'languages/languageDescription',
  gender = 'gender',
  locationId = 'location/locationId',
  yearsInPractice = 'yearsInPractice',
  specialty = 'specialties/specialtyName'
}

export type ProviderFacets = Record<ProviderFacetKeys, FacetDocument[]>;

export interface ProviderSpecialty {
  group: string;
  name?: string;
  value: string;
}

export interface ProviderSpecialtiesPayload {
  input: string;
}
